import script from "./ProdutosMapaTabPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutosMapaTabPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__